/** @file throwError: throws a Pose3DError with a code, params and an optional document path and hint. */
import type { Pose3DError } from './pose3DError';

/** Where the error points (`path`, a JSON pointer) and what to do about it (`hint`). */
export type ErrorContext = { path?: string; hint?: string };

/**
 * Throws a `Pose3DError` (an `Error` carrying the Pose3DError fields, all enumerable); message is `code` or `code at path`.
 */
export function throwError(code: string, params: Record<string, unknown> = {}, ctx: ErrorContext = {}): never {
  const message = ctx.path === undefined ? code : `${code} at ${ctx.path}`;
  const fields: Pose3DError = {
    name: 'Pose3DError', code, params,
    ...(ctx.path === undefined ? {} : { path: ctx.path }),
    ...(ctx.hint === undefined ? {} : { hint: ctx.hint }),
    message,
  };
  const error = new Error(message);
  Object.defineProperty(error, 'message', { enumerable: true });
  throw Object.assign(error, fields);
}
